import styled from 'styled-components';
import React from 'react';
import _ from 'lodash';
import * as icons from '@styled-icons/material';

const iconSetup = (type) => {
    if (!type) return 'width: 14px; ';

    return `
            width: var(--icon-size-${type}); 
        `;
};

const IconContainer = styled.span`
    svg {
        ${({type}) => iconSetup(type)};
    }
`;

const Icon = ({icon, ...props}) => {
    const iconRealName = _.findKey(icons, (_, n) => n.toUpperCase() === (icon || '').toUpperCase());

    if (iconRealName != null) {
        const RenderIcon = icons[iconRealName];
        return (
            <IconContainer>
                <RenderIcon {...props} />
            </IconContainer>
        );
    }

    return null;
};

export default IconContainer;
export {Icon};
